import { cn } from "@/lib/utils";

const FormErrorLabel = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <label
      className={cn(
        "text-[10px] text-red-700 absolute bottom-[-16px]",
        className
      )}
    >
      {children}
    </label>
  );
};

export default FormErrorLabel;
